import React from 'react'
import { StyleSheet } from 'react-native'

import { Box } from 'widgets/Box'
import { Pressable } from 'widgets/Pressable'
import { FontSizes, Text } from 'widgets/Text'

import { SpacingTypes } from 'utils/themes/types'

interface FilledButtonTypes {
  onPress?: () => void
  title?: string
  loading?: boolean
  disabled?: boolean
  width?: number
  height?: number
  fontSize?: FontSizes
  borderRadius?: SpacingTypes
}

const styles = StyleSheet.create({
  button: {
    color: 'white',
  },
  opaqueContainer: {
    opacity: 0.5,
  },
})

export const FilledButton = ({
  onPress,
  title,
  loading,
  disabled = false,
  width,
  height = 50,
  fontSize = 'md',
  borderRadius = 'xs',
}: FilledButtonTypes) => (
  <Box>
    <Pressable disabled={disabled || !onPress} onPress={onPress}>
      <Box
        width={width ?? undefined}
        height={height}
        borderRadius={borderRadius}
        padding={!width ? { horizontal: 'sm' } : undefined}
        backgroundColor='v2primary'
        justifyContent='center'
        align='center'
        style={(loading || disabled) && styles.opaqueContainer}
      >
        <Text fontSize={fontSize} style={styles.button} bold>
          {loading ? 'Loading...' : title}
        </Text>
      </Box>
    </Pressable>
  </Box>
)
